/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Program_DInputs */



/**
* | output |
* | --- |
* | "Program D" |
*
* @param {Subtitle_Export_Program_DInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_program_d = /** @type {((inputs?: Subtitle_Export_Program_DInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Program_DInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Programme D")
	if (locale === "de") return /** @type {LocalizedString} */ ("Programm D")
	if (locale === "it") return /** @type {LocalizedString} */ ("Programma D")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Программа D")
	if (locale === "es") return /** @type {LocalizedString} */ ("Programa D")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("程序 D")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プログラムD")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कार्यक्रम डी")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Programa D")
	return /** @type {LocalizedString} */ ("Program D")
});